import { Selector } from "@reduxjs/toolkit";

import { ModulFState } from "../store";

export function getDomIdForA11yId(a11yId: string): Selector<ModulFState, string | undefined> {
	return state => state.accessibility.a11yIdsToDomIds[a11yId];
}
